'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { sizeToIconSize } from '../../core-components/CoreButton';
import React from 'react';
import { InternalProvider } from '../../util';
import { Icon } from '../Icon';
import { AnchorButtonVariant, BtnVariantIconWrapper } from './ButtonVariant';
import { Anchor, IconWrapper } from './elements';
export const Link = /*#__PURE__*/React.forwardRef(({
  anchorClassName = '',
  iconClassName = '',
  color = 'primary',
  disabled = false,
  iconSrc,
  iconSide = 'left',
  variant = 'default',
  btnVariantProps = {
    btnSize: 'medium',
    btnVariant: 'default'
  },
  children,
  ...restProps
}, fRef) => {
  const renderIcon = () => variant === 'button' ? /*#__PURE__*/React.createElement(BtnVariantIconWrapper, {
    $iconSide: iconSide,
    $size: btnVariantProps.btnSize,
    $childrenPresent: !!children
  }, /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc,
    size: sizeToIconSize[btnVariantProps.btnSize],
    fill: "currentColor"
  })) : /*#__PURE__*/React.createElement(IconWrapper, {
    $iconSide: iconSide,
    className: iconClassName
  }, /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc,
    size: "small",
    fill: "currentColor",
    "data-testid": `link-icon-${iconSide}`
  }));
  return /*#__PURE__*/React.createElement(InternalProvider, null, variant === 'default' && /*#__PURE__*/React.createElement(Anchor, _extends({
    $color: color === 'white' ? 'inverted' : color,
    className: `${disabled ? 'disabled' : ''} ${anchorClassName}`,
    ref: fRef,
    $iconPresent: !!iconSrc,
    "aria-disabled": disabled ? true : undefined,
    tabIndex: disabled ? -1 : undefined
  }, restProps, {
    "data-aui": "link"
  }), iconSrc && iconSide === 'left' && renderIcon(), children, iconSrc && iconSide === 'right' && renderIcon()), variant === 'button' && /*#__PURE__*/React.createElement(AnchorButtonVariant, _extends({
    ref: fRef,
    className: `${disabled ? 'disabled' : ''} ${anchorClassName}`,
    $childrenPresent: !!children,
    $iconPresent: !!iconSrc,
    $iconSide: iconSide,
    $useFigmaStyles: false,
    $btnColor: color === 'inverted' ? 'secondary' : color,
    $btnSize: btnVariantProps.btnSize,
    $btnVariant: btnVariantProps.btnVariant,
    "aria-disabled": disabled ? true : undefined,
    tabIndex: disabled ? -1 : undefined
  }, restProps, {
    "data-aui": "link"
  }), iconSrc && iconSide === 'left' && renderIcon(), children, iconSrc && iconSide === 'right' && renderIcon()));
});